import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SenderChooserComponent } from './sender-chooser.component';
import { GalaxyWrapModule } from '@vendasta/galaxy/galaxy-wrap';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { EmailUII18nModule } from '../../src/lib/i18n/email-ui-i18n.module';

@NgModule({
  declarations: [SenderChooserComponent],
  exports: [SenderChooserComponent],
  imports: [
    CommonModule,
    TranslateModule,
    EmailUII18nModule,
    GalaxyWrapModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatInputModule,
  ],
})
export class SenderChooserModule {}
